import { render, staticRenderFns } from "./collocation.vue?vue&type=template&id=8184110e&scoped=true&"
import script from "./collocation.vue?vue&type=script&lang=js&"
export * from "./collocation.vue?vue&type=script&lang=js&"
import style0 from "./collocation.vue?vue&type=style&index=0&id=8184110e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8184110e",
  null
  
)

export default component.exports